import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManageBooking/ViewDetails/Views/view-details.html';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import Pager from '@/Pages/Admin/Modules/Common/Controllers/Pager';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {TrekBookingModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Booking/TrekBookingModel';

@WithRender
@Component({
    components: {
        Pager,
        'validation-error': ValidationError,
    },
})
export default class ViewDeparture extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                    getBookingDetail: false,
                    downloadPdf: false,
                },
                postLoading: {
                    sendEmail: false,
                },
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
                modal: {
                    email: {},
                },
            },
        };

        this.item = {
            bookingData: new TrekBookingModel({}),
            subTotal: 0,
            emailData: '',
        };
    }

    public mounted() {
        this.getBookingDetail();
    }

    public getBookingDetail() {
        this.ui.status.isLoading.getBookingDetail = true;
        let data = {
            booking_id: this.$route.query.id,
        };
        trekService
            .bookingDetailsList(data)
            .then((res: any) => {
                this.item.bookingData = res.data.data;
                this.calculateSubTotal();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then((res: any) => {
                    this.ui.error.has_error = true;
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getBookingDetail = false;
            });
    }

    public calculateSubTotal() {
        this.item.subTotal =
            Number(this.item.bookingData.total_price) +
            Number(this.item.bookingData.saved_price);
    }

    public showModal() {
        $('#cancelBooking').modal('show');
    }

    public cancelModal() {
        $('#cancelBooking').modal('hide');
        $('.modal-backdrop').remove();
    }


    public showSendEmailModal() {
        this.resetError();
        this.ui.error.modal.email = {};
        this.ui.status.postLoading.sendEmail = false;
        this.item.emailData = this.item.bookingData.customer.email;
        $('#sendemail').modal('show');
    }

    protected sendEmailAction() {
        this.resetError();
        this.ui.error.modal.email = {};
        if (!this.validateSendEmailAction()) {
            return;
        }
        this.ui.status.postLoading.sendEmail = true;
        let data = {
            email: this.item.emailData,
            booking_id: this.item.bookingData.uuid,
        };
        trekService
            .sendEmail(data)
            .then((res: any) => {
                flashService.Success('Email Sent', res.data.message);
                this.hideSendEmailModal();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.modal.email).then((res: any) => {
                    this.ui.error.has_error = true;
                    this.ui.error.modal.email = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.sendEmail = false;
            });
    }

    protected validateSendEmailAction() {
        if (!this.item.emailData) {
            Object.assign(this.ui.error.errors, {
                email: ['The email field is required.']
            });
        } else {
            let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (this.item.emailData.match(mailformat)) {
                return true;
            } else {
                Object.assign(this.ui.error.errors, {
                    email: ['Invalid email format.']
                });
            }
        }

        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    public hideSendEmailModal() {
        this.resetError();
        this.ui.error.modal.email = {};
        this.ui.status.postLoading.sendEmail = false;
        this.item.emailData = '';
        $('#sendemail').modal('hide');
        $('.modal-backdrop').remove();
    }


    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }

    public downloadPdf() {

        let data = {
            booking_id: this.item.bookingData.uuid,
        };
        this.ui.status.isLoading.downloadPdf = true;
        trekService
            .downloadPdf(data)
            .then((res: any) => {
                // console.log("Download Pdf", res.data.data);
                var link = document.createElement('a');
                link.href = res.data.data;
                let fileName = link.href.substring(link.href.lastIndexOf('/') + 1);
                // console.log("File check", fileName);
                link.download = fileName;
                link.dispatchEvent(new MouseEvent('click'));
                // window.open(res.data.data, '_blank');
                this.calculateSubTotal();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
                    this.ui.error.has_error = true;
                    this.ui.error.errors = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.downloadPdf = false;
            });
    }

    public get buttonTextSendEmail() {
        if (this.ui.status.postLoading.sendEmail) {
            return 'Processing...';
        }
        return 'Ok';
    }
}
